import { Component, Input, OnInit, Output } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { EmployeeModel } from '../../../models';
import { SelectItem } from '../../../shared';
import { LoggingService } from '../../../shared/services/logging';

@Component({
    selector: 'ef-send-bill-presenter',
    templateUrl: './send-bill-presenter.component.html',
    styleUrls: ['./send-bill-presenter.component.scss'],
    standalone: false
})
export class SendBillPresenterComponent implements OnInit {
    @Input() public items: EmployeeModel[] = [];
    @Output() public SendBills = new ReplaySubject<SelectItem[]>(1);
    public selectedContractors: EmployeeModel[];
    constructor(private log: LoggingService) {}

    ngOnInit(): void {}
}
